import { Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../theme";

const defaultProps = {
  fontWeight: "normal",
  color: COLORS.black,
};

export const H1 = ({ children, fontWeight, color }) => {
  return (
    <Typography variant="h1" sx={{ fontWeight, color }}>
      {children}
    </Typography>
  );
};

H1.propTypes = {
  fontWeight: PropTypes.string,
  color: PropTypes.string,
};

H1.defaultProps = defaultProps;

export default H1;
